import  { useEffect, useState } from "react";

import {
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterMessage,
  resetFixedAssetRegisterStatusCode,
  resetFixedAssetRegisterSuccess,
  resetSingleFixedAsset,
} from "../../redux/fixedAsset";
import { resetSession } from "../../redux/auth";
import {
  deleteFixedAssetRegisterAction,
  getSingleFixedAsset,
  postFixedAssetVerificationAction,
} from "../../redux/fixedAsset/actions";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";

import {
  EmptyListPage,
  ErrorSuccessModal,
} from "../../components/commons";

import { FixedAssetVerificationType } from "../../commonTypes/fixedAssetRegisterTypes";

import "./style.scss";

import AssetDetails from "../../components/PhysicalVerification/AssetDetails";
import { useParams } from "react-router-dom";
import { UnauthorizeImage } from "../../assets/images";

type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  fetching: boolean;

  dispatchResetSession: () => void;
  dispatchResetFixedAssetRegisterError: () => void;

  dispatchResetFixedAssetRegisterSuccess: () => void;

  dispatchGetSingleFixedAsset: (data: any) => void;
  dispatchPostFixedAssetVerificationAction: (
    data: FixedAssetVerificationType
  ) => void;
  finacAssetListing: [];
  dispatchDeleteFixedAssetRegisterAction: (data: any) => void;
  dispatchResetFixedAssetRegisterMessage: () => void;
  dispatchResetFixedAssetRegisterTotalCount: () => void;
  dispatchResetFixedAssetRegisterStatusCode: () => void;

  dispatchResetSingleFixedAsset: () => void;

  singleFixedAsset: any;
};

const PhysicalVerificationIdentity = ({
  history,
  token,
  statusCode,
  success,
  message,
  fetching,
  error,
  singleFixedAsset,

  dispatchResetSession,
  dispatchGetSingleFixedAsset,
  dispatchResetFixedAssetRegisterError,
  dispatchResetFixedAssetRegisterSuccess,

  dispatchResetFixedAssetRegisterMessage,

  dispatchResetFixedAssetRegisterStatusCode,
  dispatchPostFixedAssetVerificationAction,
  dispatchResetSingleFixedAsset,
}: AppProps) => {
  let { clientcode, id }: any = useParams();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });

    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterMessage();

    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterError();
    dispatchResetSingleFixedAsset();
  }, []);

  useEffect(() => {
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterError();
    if (id && clientcode && token) {
      let finalData = {
        token,
        client_code: clientcode,
        id,
      };
      dispatchGetSingleFixedAsset(finalData);
    }
  }, []);

  const handleSubmit = (condition: string, id: string) => {
    let finalData: FixedAssetVerificationType = {
      token,
      condition,
      fixed_asset_id: id,
      client_code: clientcode,
    };
    dispatchPostFixedAssetVerificationAction(finalData);
  };

  const handleReset = () => {
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterMessage();

    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterError();
    dispatchResetSingleFixedAsset();
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetFixedAssetRegisterError();
              dispatchResetFixedAssetRegisterSuccess();
              dispatchResetFixedAssetRegisterMessage();
              dispatchResetFixedAssetRegisterStatusCode();
            }}
          />
        );
      }
    }
  };

  return (
    <>
      <div className="physical-verification">
        {windowWidth <= 430 && singleFixedAsset?.id ? (
          <AssetDetails
            handleReset={handleReset}
            singleFixedAsset={singleFixedAsset}
            handleSubmit={handleSubmit}
            message={message}
            history={history}
            clientCode={clientcode}
          />
        ) : (
          <div className="mt-5">
            <EmptyListPage
              title="Please Login From Mobile Device To Visit This Page"
              image={UnauthorizeImage}
              imageWidth="25%"
            />
          </div>
        )}
        {handleErrorModal()}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.fixedAssetRegister.success,
  fetching: state.fixedAssetRegister.fetching,
  message: state.fixedAssetRegister.message,
  statusCode: state.fixedAssetRegister.statusCode,
  error: state.fixedAssetRegister.error,
  finacAssetListing: state.fixedAssetRegister.finacAssetListing,
  totalCount: state.fixedAssetRegister.totalCount,
  departmentList: state.clientSettings.departmentList,
  singleFixedAsset: state.fixedAssetRegister.singleFixedAsset,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFixedAssetRegisterSuccess: () =>
    dispatch(resetFixedAssetRegisterSuccess()),

  dispatchResetFixedAssetRegisterError: () =>
    dispatch(resetFixedAssetRegisterError()),
  dispatchDeleteFixedAssetRegisterAction: (data: any) =>
    dispatch(deleteFixedAssetRegisterAction(data)),
  dispatchResetFixedAssetRegisterMessage: () =>
    dispatch(resetFixedAssetRegisterMessage()),
  dispatchResetFixedAssetRegisterStatusCode: () =>
    dispatch(resetFixedAssetRegisterStatusCode()),

  dispatchGetSingleFixedAsset: (data: any) =>
    dispatch(getSingleFixedAsset(data)),
  dispatchResetSingleFixedAsset: () => dispatch(resetSingleFixedAsset()),
  dispatchPostFixedAssetVerificationAction: (
    data: FixedAssetVerificationType
  ) => dispatch(postFixedAssetVerificationAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhysicalVerificationIdentity);
